export default __webpack_public_path__ + "static/media/404.7c4bc3b4.svg";